import React, { useEffect } from 'react';
import { Box, CssBaseline } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store/store';
import { setCurrentView } from '../../store/appSlice';
import NavigationSidebar from './NavigationSidebar';
import DashboardView from '../views/DashboardView';
import AnalyticsView from '../views/AnalyticsView';
import MapView from '../views/MapView';
import UserManagementView from '../views/UserManagementView';
import KnowledgeBaseView from '../views/KnowledgeBaseView';
import { NavigationRoute } from '../../types/enums';
import { track as trackAmplitude } from '../../services/amplitude';

const AppContainer = styled(Box)({
  display: 'flex',
  height: '100vh',
});

const MainContent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  marginLeft: 20,
  marginTop: 20,

  backgroundColor: theme.palette.background.default,
  overflow: 'hidden',
}));

const AppLayout: React.FC = () => {
  const dispatch = useDispatch();
  const currentView = useSelector((state: RootState) => state.app.currentView);

  useEffect(() => {
    trackAmplitude('Page Viewed', {
      page_name: currentView,
      page_title: currentView.charAt(0).toUpperCase() + currentView.slice(1).replace('_', ' '),
    });
  }, []); // Only on mount

  const renderCurrentView = () => {
    switch (currentView) {
      case NavigationRoute.DASHBOARD:
        return <DashboardView />;
      case NavigationRoute.ANALYTICS:
        return <AnalyticsView />;
      case NavigationRoute.MAP:
        return <MapView />;
      case NavigationRoute.USER_MANAGEMENT:
        return <UserManagementView />;
      case NavigationRoute.KNOWLEDGE_BASE:
        return <KnowledgeBaseView />;
      default:
        return <DashboardView />;
    }
  };

  return (
    <AppContainer>
      <CssBaseline />
      <NavigationSidebar />
      <MainContent>
        {renderCurrentView()}
      </MainContent>
    </AppContainer>
  );
};

export default AppLayout;
